import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JetMediaShuttleWorkflowIntroduction() {
    return (
        <React.Fragment>
            <p>
                Jet system-to-system automated transfers can be combined with Media Shuttle to send and receive content
                within and between organizations. Combining both applications can help extend workflows from internal
                company systems to other companies, partners, and customers.
            </p>
        </React.Fragment>
    );
}

JetMediaShuttleWorkflowIntroduction.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JetMediaShuttleWorkflowIntroduction);
